import "./StackLinkElement-style";
import { UrlProvider } from "lib/UrlProvider";
import { StackStore, Linkstack } from "features/stacks/StackStore";

class StackLinkElement extends HTMLElement {
    async connectedCallback() {
        if (this.hasAttribute("rendered"))
            return;

        const stack = await StackStore.instance.getStackById(this.getAttribute("stack-id"));

        if (!stack)
            return;
            
        this.innerHTML = this.view(stack);
    }

    private view = (stack: Linkstack) => `
        <a href="${new UrlProvider().root}/@${stack.author.userId}/stacks/${stack.slug}#${this.getAttribute("link-id")}"
           draggable=false
           route>
           
            <div>My stacks</div>
            ${require("!!raw-loader!image/icons/divider-12.svg")}
            <div class="stack-title">${stack.title}</div>
        </a>`;
}

customElements.define("stack-link", StackLinkElement);